import { match, P } from 'ts-pattern';

import { Currency } from '../types/GlobalTypes';

/**
 *
 * 통화 기준으로 통화 포맷을 만들어줍니다. currencyString 은 커스텀한 원화기호를 넣을수있습니다.
 * */
export const fCurrency = (
  _price: number,
  currency: Currency,
  options?: { currencyString?: string; position?: 'pre' | 'post' },
): string => {
  const price = Number(_price);

  return match({ currency, price, options })
    .with({ currency: 'KRW', price: P.number }, () => {
      const { currencyString, position = 'post' } = options ?? {
        position: 'post',
        currencyString: undefined,
      };

      if (!currencyString) {
        return price.toLocaleString('KR', {
          style: 'currency',
          currency,
        });
      }

      return position == 'post'
        ? price.toLocaleString('KR') + currencyString
        : currencyString + price.toLocaleString('KR');
    })
    .with({ currency: 'JPY', price: P.number }, () => {
      return price.toLocaleString('ja-JP', {
        currency: 'JPY',
        style: 'currency',
      });
    })
    .with({ currency: 'USD', price: P.number }, () => {
      return formatUSD(price);
    })
    .otherwise(() => {
      return (price || '').toLocaleString();
    });
};

/**
 *  특정 숫자 단위로 표현하는 currency 포맷 함수 입니다,
 *  @example
 *  50000000 Price / 10000  formatUnit => 5,000 만원(wonString) 으로 표시하는 기능입니다. 현재는 한글만 표현하고 있습니다
 * */
export const fCurrencyByUnit = (
  _price: number,
  currency: Currency,
  options: FcurrencyByUnitOptions,
): string => {
  const price = Number(_price);

  return match({ currency, price })
    .with({ currency: 'KRW', price: P.number }, () => {
      return (price / options.formatUnit).toLocaleString('KR').toString();
    })
    .with({ currency: 'JPY', price: P.number }, () => {
      return formatUSD(price);
    })
    .with({ currency: 'USD', price: P.number }, () => {
      return formatUSD(price);
    })
    .otherwise(() => {
      return (price || '').toLocaleString();
    });
};

const formatUSD = (price: number) => {
  const decimalPlaces = price.toString().split('.')[1]?.length || 0;
  return price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimalPlaces > 2 ? 2 : decimalPlaces, // 소수점 표시
  });
};

export type FcurrencyByUnitOptions = {
  formatUnit: 10000 | 1;
  currencyString: string;
};
